import React, { useEffect } from "react";
import {
  RestlessTable,
  RestlessButtonFormatter,
  RestlessInteractionsFormatter,
  RestlessSourceFormatter,
} from "../../../_metronic/layout/components/Table";
import * as actions from "../../../redux/actions/comments";
import {
  disabledUser,
  kickedUser,
  shadowbanUser,
} from "../../../redux/actions/users";
import { useDispatch, useSelector } from "react-redux";
import RestlessDateFormatter from "../../../_metronic/layout/components/Table/RestlessDateFormatter";
import RestlessBooleanFormatter from "../../../_metronic/layout/components/Table/RestlessBooleanFormattear";
import { Route } from "react-router-dom";
import RestlessModerationModal from "../../../_metronic/layout/components/modeationModal/RestlessModerationModal";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import RestlessCommentsDialog from "./RestlessCommentsDialog/RestlessCommentsDialog";
import { Alert } from "react-bootstrap";

export default function RestlessCommentsPage({ history }) {
  const dispatch = useDispatch();

  const {
    commentsList,
    listLoading,
    error,
    hideLoading,
    commentHided,
  } = useSelector((state) => ({
    commentsList: state.comments.commentsList || [],
    listLoading: state.comments.listLoading,
    error: state.comments.error,
    hideLoading: state.comments.hideLoading,
    commentHided: state.comments.commentHided,
  }));

  useEffect(() => {
    dispatch(actions.fetchComments());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const buttonsArr = [
    {
      onClickFunction: (row) => {
        return commentsUIEvents.openCommentsDetailsDialog(row);
      },
      icon: (
        <SVG title="Detail" src={toAbsoluteUrl("/media/svg/icons/Text/Bullet-list.svg")} />
      ),
      title: "Detail"
    },
    {
      onClickFunction: (row) => {
        return commentsUIEvents.openModerateCommentsDialog(row);
      },
      disabled: true,
      icon: (
        <SVG title="Moderate" src={toAbsoluteUrl("/media/svg/icons/General/Settings-1.svg")} />
      ),
      title: "Moderate"
    },
  ];

  const commentsUIEvents = {
    openCommentsDetailsDialog: (row) => {
      history.push({
        pathname: `/comments/${row.id}/details`,
        state: { row: row },
      });
    },
    openModerateCommentsDialog: (row) => {
      history.push({
        pathname: `/comments/${row.id}/moderate`,
        state: { row: row },
      });
    },
  };

  const columns = [
    {
      dataField: "restless_user.full_name",
      text: "Author",
      sort: true,
    },
    {
      dataField: "id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "created_at",
      text: "Created",
      sort: true,
      formatter: RestlessDateFormatter,
    },
    {
      dataField: "type",
      text: "Type",
      sort: true,
      formatter: RestlessSourceFormatter,
    },
    {
      dataField: "deleted",
      text: "Deleted",
      sort: true,
      formatter: RestlessBooleanFormatter,
    },
    {
      dataField: "reaction",
      text: "Reaction",
      sort: true,
      formatter: RestlessInteractionsFormatter,
    },
    {
      dataField: "info.comments",
      text: "Comments",
      sort: true,
      formatter: RestlessInteractionsFormatter,
    },
    {
      dataField: "reports",
      text: "Reports",
      sort: true,
      formatter: RestlessInteractionsFormatter,
    },
    {
      dataField: "action1",
      formatter: RestlessButtonFormatter,
      formatExtraData: { buttonsArr },
    },
  ];

  const onSubmit = (values, row) => {
    if (values.moderateUser && values.userAction === "Disable_on_social") {
      dispatch(disabledUser({ id: row.restless_user.id, disableOnSocial: true }));
    }
    if (values.moderateUser && values.userAction === "Disable_on_self") {
      dispatch(disabledUser({ id: row.restless_user.id, disableOnSelf: true }));
    }
    if (values.moderateUser && values.userAction === "Kickout") {
      dispatch(kickedUser(row.restless_user.id));
    }
    if (values.moderateUser && values.userAction === "Shadowban") {
      dispatch(shadowbanUser(row.restless_user.id));
    }
    dispatch(actions.hideComments(values));
    history.push("/comments");
  };

  const renderCommentHidedStatus = () => {
    return (
      <Alert variant="success" className="text-center" dismissible>
        The comment has been deleted succesfully
      </Alert>
    );
  };

  const renderCommentError = () => {
    return (
      <Alert variant="danger" className="text-center" dismissible>
        An error has occurred
      </Alert>
    );
  };

  return (
    <>
      {listLoading || hideLoading ? (
        <div className="d-flex justify-content-center align-content-center">
          <span className="mx-3 spinner spinner-primary"></span>
        </div>
      ) : (
        <>
          {!error && commentHided && renderCommentHidedStatus()}
          {error && !commentHided && renderCommentError()}
          <Route path="/comments/:id/details">
            {({ history, match }) => (
              <RestlessCommentsDialog
                show={match != null}
                id={match && match.params.id}
                row={history.location.state?.row}
                onHide={() => {
                  history.push("/comments");
                }}
              />
            )}
          </Route>
          <Route path="/comments/:id/moderate">
            {({ history, match }) => (
              <RestlessModerationModal
                show={match != null}
                id={match && match.params.id}
                row={history.location.state?.row}
                onSubmit={onSubmit}
                onHide={() => {
                  history.push("/comments");
                }}
                entityType="Comment"
              />
            )}
          </Route>
          <RestlessTable data={commentsList} columns={columns} withPagination />
        </>
      )}
    </>
  );
}
